// extracted by mini-css-extract-plugin
export default {"icon":"TopologyWarnings_icon__6rl+j"};